export class UserRole {
    userroletypeid: number;
    userrolename: string;
}